import { useCheckAppAccess } from './useCheckAppAccess';
import { useCurrentAppConfig } from './useCurrentAppConfig';

export const useCheckCurrentAppAccess = () => {
  const { appSlug } = useCurrentAppConfig();
  return useCheckAppAccess(appSlug);
};
